import React, { Component, createRef } from 'react';
import qs from 'query-string';
import { Redirect } from 'react-router-dom';
import { Col, Image, Row, Button } from 'react-bootstrap';

import ByPactopia from '../ByPactopia';
import { Auth, Http } from '../../../support';
import ReCAPTCHA from 'react-google-recaptcha';
import { HaveAnAccount } from './HaveAnAccount';
import PaqueteFetchInfo from './components/PaqueteFetchInfo';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import ManageCardForm from '../../../shared/checkout/ManageCardForm';
import ClienteExternalRegistrationMinimalForm from './components/ClienteExternalRegistrationMinimalForm';

class RegistroConCompra extends Component {
  state = {};

  recaptchaRef = null;

  constructor(props) {
    super(props);

    const query = qs.parse(this.props.location.search);

    this.state = {
      query,
      paqueteId: query.pk || '',
      licencia: query.licencia || 'm',
      selectedTab: '1',
      data: {},
      paquete: undefined,
    };

    this.recaptchaRef = createRef();
  }

  componentDidMount() {
    const { query } = this.state;

    if (!query.pk) {
      this.props.history.replace({
        pathname: `/auth/registro/simple`,
      });
    }
  }

  handleOnChange = (event) => {
    this.setState({
      error: undefined,
      ...event,
    });
  };

  handleOnSubmit = async () => {
    this.setState({ error: undefined });

    const token = await this.recaptchaRef.current.executeAsync();

    const { data } = this.state;

    const details = {
      name: data.nombre_comercial,
      email: data.email,
      challenge: token,
    };

    const { error, payment } = await this.state.payment(details);

    if (error) {
      this.setState({
        ...this.state,
        error,
      });

      return;
    }

    const body = {
      ...data,
      razon_social: 'Mi empresa',
      rfc: 'XAXX010101000',
      ...payment,
      usuario: {
        nombre: data.nombre_comercial,
        email: data.email,
        password: data.password,
      },
      paquete: {
        id: this.state.paqueteId,
        licencia: this.state.licencia,
      },
    };

    await this.submit(body);
  };

  async submit(data) {
    this.setState({
      busy: true,
    });

    try {
      let response = await Http.post('api/ext/clientes', data);

      this.logIn(response);
    } catch (error) {
      this.setState({
        error: error.data || error,
      });
    } finally {
      this.setState({
        busy: false,
      });
    }
  }

  logIn = async (response) => {
    const { access_token, ...rest } = response.data ?? {};

    const user = {
      ...rest,
      empresa: undefined,
      cliente: undefined,
      emisor: undefined,
    };

    const { empresa, emisor, cliente } = rest;

    const data = {
      token: { access_token },
      user,
      empresa,
      emisor: emisor || {},
      cliente: cliente || {},
    };

    await Auth.setData(data);

    this.setState({
      isLoggedIn: true,
      busy: false,
    });
  };

  renderError = () => {
    const { error } = this.state;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          variant="inline"
          error={error}
          onAction={() => {}}
        />
      </div>
    );
  };

  handleOnTabChange = (event) => {
    this.setState({
      ...this.state,
      selectedTab: event,
    });
  };

  handleOnCreditCardChange = (event) => {
    this.setState({
      ...this.state,
      isValidCreditCard: event.isValid,
      payment: event.payment,
    });
  };

  handlePaqueteFetchInfo = (event) => {
    this.setState({
      ...this.state,
      paquete: event,
    });
  };

  onCaptchaChange = (value) => {
    const { data } = this.state;

    this.setState({
      data: {
        ...data,
        challenge: value,
      },
    });
  };

  render() {
    const { isValid, isValidCreditCard, isLoggedIn, busy, data, paquete, error, selectedTab, licencia, query } =
      this.state;

    if (isLoggedIn) {
      let { from } = this.props.location.state || { from: { pathname: '/app/dashboard' } };

      let to = {
        pathname: `/cuenta/paquetes/${paquete.data.id}`,
        search: `licencia=${licencia}&intro=1&compra=1`,
      };

      return (
        <Redirect
          to={to}
          state={from}
        />
      );
    }

    return (
      <>
        <div className="auth-content">
          {/* Avatar */}
          <div className="avatar mt-4">
            <div className="auth-logo">
              <div className="d-flex justify-content-start">
                <Image
                  src="/img/logo.png"
                  className="auth-logo-img opacity-6"
                  fluid={true}
                />
                <p className="title text-muted">Facturotöpia</p>
              </div>

              {!paquete && (
                <div className="pb-3">
                  <PaqueteFetchInfo
                    id={this.state.paqueteId}
                    onChange={this.handlePaqueteFetchInfo}
                  />
                </div>
              )}

              {!!paquete && paquete.success && (
                <div className="pb-3">
                  <strong className="subtitle text-upper">
                    {selectedTab === '1' ? 'Datos de tu cuenta' : 'Tu pago'}
                  </strong>
                </div>
              )}
            </div>
          </div>

          {/* Registro */}
          {!!paquete && paquete.success && (
            <div className="login-content">
              <div className={`${selectedTab === '1' ? 'visible' : 'invisible'}`}>
                <ClienteExternalRegistrationMinimalForm
                  data={data}
                  onChange={this.handleOnChange}
                />
              </div>

              <div className={`${selectedTab === '2' ? 'visible' : 'invisible'}`}>
                <Row className="pt-1 pb-3">
                  <Col>
                    <div className="border-top border-bottom py-3">
                      <Row className="">
                        <Col sm="6">
                          <div className="d-block text-muted">{paquete.data.nombre}</div>
                          <div className="d-block">
                            {paquete.data.hits === 'ilimitado' ? 'Hits ilimitados' : `${paquete.data.hits} hits`}
                          </div>
                        </Col>
                        <Col className="text-right">
                          $ {licencia === 'y' ? paquete.data.costo_anual : paquete.data.costo_mensual} + IVA
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <ManageCardForm onChange={this.handleOnCreditCardChange} />
              </div>

              <ReCAPTCHA
                size="invisible"
                ref={this.recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                onChange={this.onCaptchaChange}
              />

              <Row className="pt-3">
                <Col className="text-right">
                  {selectedTab === '1' && (
                    <Button
                      type="button"
                      variant="secondary"
                      disabled={!isValid || busy}
                      onClick={this.handleOnTabChange.bind(this, '2')}
                    >
                      Siguiente
                    </Button>
                  )}
                  {selectedTab === '2' && (
                    <>
                      <Button
                        type="button"
                        variant="secondary"
                        className="mr-3"
                        disabled={busy}
                        onClick={this.handleOnTabChange.bind(this, '1')}
                      >
                        Regresar
                      </Button>
                      <LoadingButton
                        type="button"
                        loading={busy}
                        disabled={!isValid || !isValidCreditCard || busy}
                        onClick={this.handleOnSubmit}
                      >
                        {busy && 'Procesando...'}
                        {!busy && 'Crear mi cuenta'}
                      </LoadingButton>
                    </>
                  )}
                </Col>
              </Row>

              <div className="pt-3">{!!error && this.renderError()}</div>
            </div>
          )}

          <HaveAnAccount tenancy={query.tenancy} />

          {/* Footer */}
          <div className="pt-3">
            <ByPactopia />
          </div>
        </div>
      </>
    );
  }
}

export default RegistroConCompra;
